"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AllowedOrigins = {
    type: "list",
    flattened: true,
    member: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_AllowedOrigins.js.map